import instance from '@/utils/instance';

//获取企业列表- corporate
export function getCorporateList() {
	return instance({
		url: `/webL_api/corporate/acc/getCorporate`,
		method: 'get'
	});
}

//获取客户信息
export function getMemberGetInfo() {
	return instance({
		url: `/webL_api/consumer/member/getInfo`,
		method: 'get'
	});
}

//更新客户信息
export function postMemberUpdateInfo(params) {
	return instance({
		url: `/webL_api/consumer/member/updateInfo`,
		method: 'post',
		data: params
	});
}

//刷新客户信息
export function postMemberRefreshInfo() {
	return instance({
		url: `/webL_api/consumer/member/refresh`,
		method: 'post'
	});
}

//旧手机号验证
export function postMemberPhoneOld(params) {
	return instance({
		url: `/webL_api/consumer/member/phone/old`,
		method: 'post',
		data: params
	});
}

//新手机号验证
export function postMemberPhoneNew(params) {
	return instance({
		url: `/webL_api/consumer/member/phone/new`,
		method: 'post',
		data:params
	});
}

//更新客户信息
export function postMemberUpdatePhoneMail(params) {
	return instance({
		url: `/webL_api/consumer/member/updatePhone`,
		method: 'post',
		data:params
	});
}

//更新密码
export function postMemberUpdatePhonePwd(params) {
	return instance({
		url: `/webL_api/consumer/member/updateConsumerPwd`,
		method: 'post',
		data:params
	});
}

//合并账户
export function postMemberReplaceConsumer(params) {
	return instance({
		url: `/webL_api/consumer/member/replaceConsumer`,
		method: 'post',
		data:params
	});
}

//注销账户
export function postMemberDeactivate() {
	return instance({
		url: `/webL_api/consumer/member/deactivate`,
		method: 'get'
	});
}

